import React  from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import styled from 'styled-components';
// import companyLogo from 'assets/images/logo_.png';
import {ReactComponent as CompanyLogo} from "assets/images/logo.svg";

import companyBg from 'assets/images/background_bg.jpg';
import * as Yup from "yup";
import useLogin from 'hooks/useLogin';

export default function Login() {
    
    const loginValues = { username: '', password: '' };
    const { doLogin, moveToPath } = useLogin();
   
    const validationSchema =
        Yup.object().shape({
            username: Yup.string()
                .matches(/^[a-z]+[a-z0-9]{3,20}$/g, "올바른 아이디 형식이 아닙니다.")
                .required("아이디를 입력해주세요."),
            password: Yup.string()
                .required("비밀번호를 입력해주세요.")
        });
   
    function submit(json) {
        
        doLogin(json).then(data => {
            if (typeof data === "undefined") {
                alert("관리자에게 문의해주세요.");
            } else if (data.error) {
                alert("아이디와 비밀번호를 다시 확인해주세요.");
            } else if (data.id !== null) {
                moveToPath("/main");
            } else {
                alert("관리자에게 문의해주세요.");
            }
        });
    }

    return (
        <section>
            <Container >
                <LoginForm>
                    {/* <LoginTitle src={companyLogo} ></LoginTitle> */}
                    <CompanyLogo width={275} style={{margin:"70px 0 0 0"}}/>
                    <Formik
                        initialValues={loginValues}
                        validationSchema={validationSchema}
                        onSubmit={submit}
                    >
                        {() => (
                            <Form >
                                <LoginBody style={{ color: "#ffffff" }}>
                                    <Field id="input_Id" type='text' name='username' placeholder="아이디를 입력해주세요." maxLength="20" as={InputBox} />
                                    <LoginBody style={{ marginTop:"-20px",height:"10px",marginLeft: "35px", fontSize: "12px", fontWeight: "none", color: "#ff0000", textAlign: "left" }}>   
                                        <ErrorMessage name="username" components='div' />
                                    </LoginBody>
                                </LoginBody>
                                <LoginBody style={{ color: "#ffffff" }}>
                                    <Field id="input_pw" type='password' name='password' placeholder="비밀번호를 입력해주세요." maxLength="15" as={InputBox} />
                                    <LoginBody style={{ marginTop:"-20px",height:"10px",marginLeft: "35px", fontSize: "12px", fontWeight: "none", color: "#ff0000", textAlign: "left" }}>   
                                        <ErrorMessage name="password" components='div' />
                                    </LoginBody>
                                </LoginBody>
                                <LoginBody>
                                {/* disabled={isSubmitting} */}
                                    <LoginBtn id="loginBtn" className="inputBtnLogin" type="submit">Login</LoginBtn>
                                </LoginBody>
                            </Form>
                        )}
                    </Formik>
                </LoginForm>
            </Container>
        </section>
    )
}

const Container = styled.div`
    min-height: 100vh;
     width:100%; 
     background:url("${companyBg}");  
     background-repeat: no-repeat ; 
     background-size: cover ; 
     background-position: center ; 
     display:flex; 
     align-items: center; 
     overflow: hidden;
`;

const LoginForm = styled.div`
    box-shadow: 5px 5px 20px rgb(7, 0, 0); 
    background:linear-gradient(rgba(50, 55, 68, 1.0),rgba(50, 55, 68, 1.0)); 
    margin : 0 auto; 
    width: 350px;
    height: 430px; 
    border-radius : 20px;
`;
const LoginTitle = styled.img`
    width:auto; 
    margin:65px 30px 60px 130px;
`;
const LoginBody = styled.div`
    width:100%; 
    text-align:center;
    margin-top : 10px;
`;
const LoginBtn = styled.button`
    width:83%;
    height:50px;
    margin-top:10px;  
    font-size:15px;
    color:#ffff; 
    background:rgba(50, 55, 68, 0.3); 
    margin-top:15px;
    border-radius : 15px;
    cursor: pointer;
    &:focus { 
        outline: 1px solid #999;
        outline-offset: 0;
    }
`;
const InputBox = styled.input`
    padding-left:13px; 
    font-size:14px; 
    border: none;
    border-bottom:1px solid #8b8b8b; 
    background: transparent; 
    width:80%;
    margin-bottom:20px; 
    height:40px;
    color:#ffff;
    &:focus { 
        outline: 0;
        outline-offset: 0;
    }
`;
